import Vue from "vue";

export enum Events {
  DropdownCloseAll = "dropdown-event/close-all"
}

export default new Vue();
